export default __webpack_public_path__ + "static/media/neuecardmunchen.23e3fc3c.svg";